import PropTypes from "prop-types";
import { Progress } from "antd";
import {
  Overlay,
  Modal,
  CloseButton,
  Title,
  Subtitle,
  ProgressWrapper,
} from "./UploadProgressStyled";

export default function UploadProgress({
  open,
  onClose,
  percent,
  title,
  subtitle,
  hideClose = false,
}) {
  if (!open) return null;

  return (
    <Overlay>
      <Modal>
        {!hideClose && (
          <CloseButton onClick={onClose} aria-label="Close">
            &#10005;
          </CloseButton>
        )}
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
        <ProgressWrapper>
          <Progress
            percent={percent}
            showInfo={false}
            strokeColor="#0C53BB"
            trailColor="#E3F0FF"
            strokeWidth={8}
          />
        </ProgressWrapper>
        {percent} %
      </Modal>
    </Overlay>
  );
}

UploadProgress.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  percent: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  hideClose: PropTypes.bool,
};
